@if (isMapConsentGiven) {
    <div class="d-flex mt-1 justify-content-end align-items-center avs-countdown-refresh">
    <!--   <div> <button mat-button-toggle (click)="toggleMeasure()">
                {{ isMeasuring ? 'Messung beenden' : 'Strecke messen' }}
            </button></div> -->

        <div class = "d-flex justify-content-end">
            <button class="btn btn-sm btn-outline-danger rounded-0 me-2" (click)="onRevokeMapConsentClicked()">
                Google-Maps-Zustimmung widerrufen
            </button>
        </div>
         <div class="text-secondary  d-flex ">
                <div style="width: 50px;" class="ms-3" >
                    <div *ngIf="isTimerActive" (click)="triggerReload()">
                    <img alt="icon reload schema data" class="opacity-50 me-1" src="assets/icons/arrow-clockwise.svg">
                    <span>{{ countdown }} s</span>
                    </div>
                </div>
        </div>
    </div>

    <div style="margin-top: 15px;" id="map"></div>
}
@else {
    <avs-map-consent></avs-map-consent>
}
